import { View } from 'backbone';
import { Model } from 'backbone';
import selectFieldModalView from 'common-views/SelectFieldModalView.js';
import formatTemplate from 'behaviors/properties/main/property.ejs';
import listService from 'ListService.js'
import controlPropertiesService from 'ControlPropertiesService.js'
import constants from 'Constants';

class SetPropertyView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.mode = 'objectsANDlists';

        this.events = {
            "click #selectObject"       : "showSelectModal",
            "change #propertyId"        : "selectProperty"
        };

        if (this.model.get('controlId')) {
            const id = this.model.attributes.controlId;
            let obj = listService.getObject( listService.cleanId(id) );
            if (!obj) {
                obj = listService.getPage(listService.cleanId(id));
            }

            let objName = '';
            let objFactoryKey = '';
            if (obj) {
                 objName = obj.model.get('name');
                 objFactoryKey = this.getControlFactoryKey(obj.model.get('factoryKey'), obj);
            }

            this.model.set('propertyFieldSelected', objName, {silent:true});
            this.model.set('propertyList', controlPropertiesService.getControlProperties(objFactoryKey), {silent:true});
            if (this.model.get('autosummary')) {
                this.model.set('widgetText', objName);
            }
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    getControlFactoryKey(factoryKey, obj){

        let fK = factoryKey;
        if (constants.GROUP_KEYS.contains(factoryKey)) {
            let selectedObject = obj;
            if (!selectedObject) {
                if (this.model.get('controlId')) {
                    const id = this.model.attributes.controlId;
                    selectedObject = listService.getObject(listService.cleanId(id));
                }
            }

            if (selectedObject) {
                if (selectedObject.model.get("hasTitle")) {
                    fK = "control_group_with_header"
                }
            }
        }
        return fK;
    }

    selectProperty(e){
        this.model.set('propertyId', e.currentTarget.value);
    }

    showSelectModal(ev) {
        ev.preventDefault();
        const factoryKey= 'modal';
        this.model.set("dataSelectedItemId", this.model.get('controlId'), {silent:true});

        var sfModal = new selectFieldModalView({model: this.model, mode: this.mode});
        sfModal.render().then((selectedField)=>{
            this.model.set('controlId', selectedField.id, {silent:true});
            this.model.set('propertyFieldSelected', selectedField.name, {silent:true});
            let factoryKey = this.getControlFactoryKey(selectedField.key);

            const propList = controlPropertiesService.getControlProperties(factoryKey);
            this.model.set('propertyList', propList);

            if (propList && propList.length > 0) {
                this.model.set('propertyId', propList[0].value, {silent: true});
            }
            this.updateWidgetText();
            this.model.trigger('change');
        }).catch(err => console.log(err));
    }

    updateWidgetText() {
        if (this.model.get('autosummary')) {
            this.model.set('widgetText', this.model.get('propertyFieldSelected'));
        }
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if(this.model.get('propertyId')) {
            $('#propertyId').find('option[value="' + this.model.get('propertyId') +'"]').attr('selected', true);
        }
        this.updateWidgetText();

        this.delegateEvents();
        return this;
    }
}

export default SetPropertyView;
